import { Image, Paper, Text } from "@mantine/core"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { AppTitle } from "@/components/utils/AppTitle"
import FinishStage from "./FinishStage"
import { QuestionsStage } from "./QuestionsStage"
import { ButtonSurvey } from "./StageButton"
import { StageControls } from "./StageControls"
import type { IStageProps } from "./types"
import WelcomeStage from "./WelcomeStage"

function SessionCancelled({ onClose }: { onClose?: () => void }) {
  const { t } = useTranslation()

  return (
    <>
      <Paper bg="linear-gradient(135deg, var(--mantine-color-cyan-3), var(--mantine-color-cyan-9))">
        <Image
          src="https://img.team-tracker.ru/survey/canceled.png"
          alt="Session cancelled"
          height={300}
          fit="contain"
        />
      </Paper>
      <AppTitle fz={36} lh="40px">
        <Text variant="gradient" gradient={{ from: "cyan", to: "blue" }} inherit>
          {t("Session unavailable")}
        </Text>
      </AppTitle>
      <Text c="dimmed" size="lg">
        {t("This session has been cancelled and is no longer available for participation.")}
      </Text>
      <StageControls>
        <ButtonSurvey variant="navy" mx="auto" onClick={() => onClose?.()}>
          {t("Close")}
        </ButtonSurvey>
      </StageControls>
    </>
  )
}

export function SurveyStages({ onClose, onStep, usersession }: Omit<IStageProps, "onNext">) {
  const { started, finished } = usersession
  const [stage, setStage] = useState<"welcome" | "questions" | "finish">(
    finished ? "finish" : started ? "questions" : "welcome",
  )

  if (usersession.session.state === "canceled" || usersession.session.state === "declined") {
    return <SessionCancelled onClose={onClose} />
  }
  return stage === "welcome" ? (
    <WelcomeStage usersession={usersession} onNext={() => setStage("questions")} onStep={onStep} />
  ) : stage === "finish" ? (
    <FinishStage usersession={usersession} onClose={onClose} onStep={onStep} onNext={() => setStage("questions")} />
  ) : (
    <QuestionsStage usersession={usersession} onNext={() => setStage("finish")} onStep={onStep} />
  )
}
